import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addLeadType, getLeadType, updateLeadType, deleteLeadType } from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class LeadType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            leadtype: ''
        }
        this.handleLeadTypeSubmit = this.handleLeadTypeSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (leadtype) => {
        this.setState({ leadtype: leadtype });
        this.setState({ deleteModal: true });
    };

    handleDeleteLeadType = () => {
        const { onDeleteLeadType } = this.props;
        const { leadtype } = this.state;

        if (leadtype.id !== undefined) {
            onDeleteLeadType(leadtype);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleLeadTypeSubmit(value) {
        this.props.addLeadType(value, this.props.history);
    }

    componentDidMount() {
        const { onGetLeadType } = this.props;
        onGetLeadType(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { leadtypes } = this.props;
        if (!isEmpty(leadtypes) && size(prevProps.leadtypes) !== size(leadtypes)) {
            this.setState({ leadtypes: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ leadtype: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const leadtype = arg;
        this.setState({
            leadtype: {
                id: leadtype.id,
                leadTypeId: leadtype.leadTypeId,
                leadTypeTitle: leadtype.leadTypeTitle,
                agentId: leadtype.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { leadtypes, onUpdateAppLeadType } = this.props;
        const { isEdit, deleteModal } = this.state;
        const leadtype = this.state.leadtype;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteLeadType}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Lead Type")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        leadTypeTitle: (this.state && this.state.leadTypeTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleLeadTypeSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Lead Type</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="leadTypeTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="leadTypeTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.leadTypeTitle && touched.leadTypeTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="leadTypeTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="leadTypeTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(leadtypes, (leadtype, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{leadtype.leadTypeTitle}</td>
                                                                        <td>
                                                                                  {leadtype.agentId > 0 ? (
                                                                            <>
                                                                              <ActionEdit onClick={() => this.toggleRightCanvas(leadtype)} />
                                                                                                                                                                                                                                                                                                            
                                                                            <ActionDelete onClick={() => this.onClickDelete(leadtype)} />
                                                                          </>
                                                                        ) : null}

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: leadtype.id,
                                        leadTypeId: leadtype.leadTypeId,
                                        leadTypeTitle: leadtype.leadTypeTitle,
                                        agentId: leadtype.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                leadTypeId: values.leadTypeId,
                                                leadTypeTitle: values.leadTypeTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateAppLeadType(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="leadTypeTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="leadTypeTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.leadTypeTitle && touched.leadTypeTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="leadTypeTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="leadTypeTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
LeadType.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addLeadType: PropTypes.func,
    onGetLeadType: PropTypes.func,
    leadtypes: PropTypes.array,
    onDeleteLeadType: PropTypes.func,
    onUpdateAppLeadType: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        leadtypes: AppoinmentObject.leadtypes,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addLeadType: (data) => dispatch(addLeadType(data)),
    onGetLeadType: (agentId) => dispatch(getLeadType(agentId)),
    onDeleteLeadType: (id) => dispatch(deleteLeadType(id)),
    onUpdateAppLeadType: (data) => dispatch(updateLeadType(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeadType))
